module.exports = __webpack_public_path__ + "img/bg-onboarding-first.90941e7f.svg";